const getAvailableTerms = (posts = [], taxonomy = '') => {
	if (!taxonomy) return [];

	if (posts.length === 0) return [];

	/**
	 * Change the taxonomy param from talk_category or talk_tag to category and tag.
	 * then gather all the term ids from the posts array.
	 *
	 * The shape of one post
	 * {
	 *     ...
	 *     taxonomies:{
	 *     	categories:[{term_id:1, ...},{term_id:2, ...}], tags:[{term_id:3, ...},{term_id:4, ...}]
	 *     	tags:[{term_id:1, ...},{term_id:2, ...}], tags:[{term_id:3, ...},{term_id:4, ...}]
	 *     }	 *
	 * }
	 */

	// Change the taxonomy param from talk_category or talk_tag to categories and tags
	const taxonomyName = taxonomy === 'talk_category' ? 'categories' : 'tags';

	const termIds = [];

	posts.forEach((post) => {
		const { taxonomies } = post;

		if (taxonomies.hasOwnProperty(taxonomyName)) {
			//console.log(taxonomies[taxonomyName]);
			if (taxonomies[taxonomyName]?.length > 0) {
				taxonomies[taxonomyName].forEach((term) => {
					termIds.push(term.term_id);
				});
			}
		}
	});

	// Filter out duplicates and return the array
	return [...new Set(termIds)];
};

export default getAvailableTerms;
